import { render, staticRenderFns } from "./Funeraria.vue?vue&type=template&id=d647c4e8"
import script from "./Funeraria.vue?vue&type=script&lang=js"
export * from "./Funeraria.vue?vue&type=script&lang=js"
import style0 from "./Funeraria.vue?vue&type=style&index=0&id=d647c4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports